import React from 'react';
import { Grid } from 'vindi-ds-components';
import EmptyState from './empty_state';

function PageEmptyState() {
  return (
    <Grid container>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
      >
        <EmptyState />
      </Grid>
    </Grid>
  );
}

export default PageEmptyState;
